import { Button } from "../Button/Button";
import { HotDealCard } from "../HotDealCard/HotDealCard";
import { Text } from "../Text/Text";
import { Stack } from "../Stack/Stack";
import Image from "next/image";
import { Box } from "../Box/Box";
import { Product } from "~/types";
import { VoucherCodeDialog } from "./VoucherCodeDialog/VoucherCodeDialog";

export function VoucherCodeDeal({
  product,
  inCart,
  onClose,
  onContinue,
  busy,
}: {
  product?: Product;
  inCart: boolean;
  onClose: () => void;
  onContinue: () => void;
  busy?: boolean;
}) {
  if (product?.id === "DAVEORONI") {
    /**
     * This is an easter egg.
     * The idea is to not tell anyone and see how long it takes to be discovered.
     * -- Stevo
     **/
    return <DaveDeal product={product} onClick={onClose} />;
  }

  if (!product) return null;

  const onClick = inCart ? onClose : onContinue;

  return (
    <VoucherCodeDialog>
      <Stack space={"5"}>
        <Text align={"center"} font="accent" weight="strong" size="large">
          {product.plu}
        </Text>

        <HotDealCard product={product} onSelect={onClick} />
        {inCart ? (
          <Text color="jets-red" size="large" weight="strong">
            This item is already in your cart, discount will be applied at check
            out
          </Text>
        ) : (
          <Text color="jets-black" size="large" weight="strong">
            Add this item to your cart now, discount will be applied at check
            out
          </Text>
        )}

        <Button primary onClick={onClick} disabled={busy}>
          Continue
        </Button>
      </Stack>
    </VoucherCodeDialog>
  );
}

function DaveDeal({
  product,
  onClick,
}: {
  product: Product;
  onClick: () => void;
}) {
  return (
    <VoucherCodeDialog>
      <Stack space={"5"}>
        <Text align={"center"} font="accent" weight="strong" size="large">
          {product.title}
        </Text>

        <>
          {product.imageUrl && (
            <Box display={"flex"} justifyContent="center">
              <Image
                src={product.imageUrl}
                alt={product.title}
                width={271}
                height={317}
              />
            </Box>
          )}
        </>

        <Text color="jets-black" size="large" weight="strong" align={"center"}>
          Site made with love by Dave, Ari, Den, Dom, Stevo, Alex, Jarrod, Jett
          (really) & Jacob.
        </Text>

        <Button primary onClick={onClick}>
          Impressed
        </Button>
      </Stack>
    </VoucherCodeDialog>
  );
}
